// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"acc38115","135":"f62af6ec","686":"fcaf303a","696":"535badde","924":"7ec73364","946":"4b745ffd"}[chunkId] + ".chunk.js";
};